import { initAddButton } from "./components/addButton";
import { initRemoveButton } from "./components/removeButton";
import { initToggler } from "./components/toggler";

const initWishlist = (options) => {
    initAddButton(options);
    initRemoveButton(options);
    initToggler(options);
};

export { initWishlist };
